<template lang="html">
  <section class="header" v-if="$route.name != 'demoIt'">
    <div class="container row-between">
      <h1>
        <router-link to="/"><img width="143px" class="h-100" src="/static/img/logo.png" alt="Logo" /></router-link>
      </h1>

      <nav class="row-start" :show="show">
        <button class="cerrar-menu" @click="show = false">✕</button>

        <div class="menu">
          <router-link router-link-exact-active :to="$t('enlaces.quienes_somos')">{{ $t("menu.quienesSomos") }}</router-link>
          <router-link router-link-exact-active :to="$t('enlaces.kit_digital')" v-if="lang == 'es'">{{ $t("menu.kitDigital") }}</router-link>
          <router-link router-link-exact-active :to="$t('enlaces.servicios')">{{
            $t("menu.servicios")
            }}</router-link>
          <router-link router-link-exact-active :to="$t('enlaces.features')" v-if="lang == 'es'">{{
            $t("menu.features")
            }}</router-link>
          <span class="menu-sub" :showSubMenu="showSubMenu" @click="toggleShowSubMenu" v-if="lang == 'es'">{{ $t("menu.recursos") }}
            <ul :showSubMenu="showSubMenu">
              <li>
                <router-link :to="$t('enlaces.blog')">{{
                  $t("menu.blog")
                  }}</router-link>
              </li>
              <li>
                <router-link :to="$t('enlaces.ebooks')">{{
                  $t("menu.ebooks")
                  }}</router-link>
              </li>
              <li>
                <router-link :to="$t('enlaces.medios')">{{
                  $t("menu.medios")
                  }}</router-link>
              </li>
              <li>
                <router-link :to="$t('enlaces.casosExito')">{{
                  $t("menu.casosExito")
                  }}</router-link>
              </li>
            </ul>
          </span>

          <router-link router-link-exact-active :to="$t('enlaces.clientes')">{{
            $t("menu.clientes")
            }}</router-link>
          <router-link router-link-exact-active :to="$t('enlaces.contacto')">{{
            $t("menu.contacto")
            }}</router-link>
        </div>

        <router-link :to="$t('enlaces.contacto')" class="btn-rounded-blue">{{
          $t("menu.demo")
          }}</router-link>
      </nav>

      <button class="show-menu" @click="show = true">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  </section>
  <section v-else class="demo-header">
    <div class="container row-center">
      <img src="/static/img/logo_white.svg" alt="">
    </div>
  </section>
</template>

<script lang="js">
  import { mapGetters } from 'vuex';
  export default {
    name: 'app-header',
    data() {
      return {
        show: false,
        showSubMenu: false
      }
    },
    mounted() {

      this.setMenuAnimacion();

      var that = this;

      $(window).scroll(function (event) {

        that.setMenuAnimacion();

      });

    },
    methods: {
      setMenuAnimacion: function () {
        let altura = $(window).scrollTop();
        if (altura > 400) {
          $(".header").addClass('rar');
        } else if ($(".header").hasClass('rar')) {
          $(".header").removeClass('rar');
        }
      },
      toggleShowSubMenu: function () {
        this.showSubMenu = !this.showSubMenu;
      },
    },
    computed: {
      ...mapGetters({
        lang: 'getLanguage'
      })
    },
    watch: {
      '$route': function () {
        this.show = false;
        this.showMenu = false;
      }
    }
  }
</script>

<style scoped>
  .header {
    padding: 10px 0;
    position: fixed;
    left: 0;
    width: 100%;
    top: 0;
    z-index: 20;
    background: #f3f7fb;
    transition: 0.5s;
    border-bottom: 1px solid #f5f8fb;
  }

  .header.rar {
    background: #e1eaf2;
    border-bottom: 1px solid #bed2e5;
    padding: 5px 0;
  }

  .header h1 a {
    display: grid;
  }

  .header img {
    transition: 0.5s;
  }

  .header.rar img {
    max-height: 70px;
    transform: scale(0.7);
  }

  .header .btn-rounded-blue {
    transition: 0.5s;
  }

  .header.rar .btn-rounded-blue {
    height: 40px;
    line-height: 40px;
    padding: 0 10px;
    font-size: 16px;
  }

  .menu {
    display: flex;
    align-items: flex-end;
  }

  .menu a,
  .menu-sub {
    font-size: 16px;
    padding: 10px;
    color: #3374b0;
    font-family: "Ubuntu Mono", sans-serif;
    overflow: hidden;
    position: relative;
    display: inline-block;
    cursor: pointer;
  }

  .menu-sub {
    padding-right: 15px;
    overflow: initial;
  }

  .menu-sub:after {
    position: absolute;
    content: "";
    background: url(/static/img/next-blue.svg) center/13px no-repeat;
    width: 15px;
    height: 15px;
    background-size: 5px;
    transform: rotate(90deg);
    right: 0;
    top: 12px;
    background-repeat: no-repeat;
  }

  .menu-sub ul {
    position: absolute;
    top: 100%;
    left: 0;
    display: none;
  }

  .menu-sub ul[showsubmenu="true"] {
    display: block;
    width: 100%;
    min-width: 200px;
    background: #f3f7fb;
    padding: 5px 0;
  }

  .menu-sub ul li {
    text-align: left;
  }

  .menu-sub ul li a {
    padding: 0 10px;
    font-weight: initial;
  }

  .menu-sub ul li a:hover {
    font-weight: 600;
  }

  .menu-sub ul li a::before {
    display: none;
  }

  .menu a::before {
    position: absolute;
    left: 0px;
    bottom: 0px;
    height: 15px;
    width: 50px;
    display: inline-block;
    background: #3374b0;
    opacity: 0.2;
    content: "";
    transition: 0.7s;
    animation-timing-function: ease-in-out;
    transform: translateX(-110%);
  }

  .menu-sub[showsubmenu="true"]::before {
    position: absolute;
    left: 0px;
    bottom: 0px;
    height: 15px;
    width: 0px;
    display: inline-block;
    background: #3374b0;
    opacity: 0.2;
    content: "";
    transition: 0.7s;
    animation-timing-function: ease-in-out;
  }

  .menu-sub[showsubmenu="true"] {
    font-weight: 600;
    color: #41566d;
  }

  .menu-sub[showsubmenu="true"]::before {
    width: 50px;
  }

  .menu a.router-link-exact-active,
  .menu a.router-link-active:not(.inicio) {
    font-weight: 600;
    color: #41566d;
  }

  .menu a.router-link-exact-active::before,
  .menu a.router-link-active:not(.inicio)::before {
    transform: translateX(0);
  }

  .btn-rounded-blue {
    margin-left: 20px;
  }

  .cerrar-menu {
    display: none;
  }

  .show-menu {
    display: none;
  }

  @media screen and (max-width: 1000px) {
    nav {
      position: fixed;
      left: 0;
      top: -120vh;
      height: 100vh;
      width: 100%;
      -webkit-flex-direction: column;
      -moz-flex-direction: column;
      -ms-flex-direction: column;
      -o-flex-direction: column;
      flex-direction: column;
      justify-content: center;
      -webkit-justify-content: center;
      background: white;
      padding: 30px 20px;
      transition: 0.7s transform cubic-bezier(0.785, 0.135, 0.15, 0.86);
      z-index: 4;
      box-shadow: 1px 3px 50px 5px rgba(117, 117, 117, 0.5);
    }

    nav[show="true"] {
      transform: translateY(120vh);
    }

    nav .menu {
      display: -webkit-flex;
      display: -moz-flex;
      display: -ms-flex;
      display: -o-flex;
      display: flex;
      justify-content: center;
      -webkit-justify-content: center;
      -ms-align-items: center;
      align-items: center;
      -webkit-flex-direction: column;
      -moz-flex-direction: column;
      -ms-flex-direction: column;
      -o-flex-direction: column;
      flex-direction: column;
      margin-bottom: 3vh;
    }

    nav .menu a,
    .menu-sub {
      font-size: 6vw;
    }

    .menu-sub:after {
      height: 6vw;
      right: -7px;
      background-size: 8px;
    }

    .menu-sub ul {
      position: initial;
      background: white !important;
    }

    .menu-sub ul li a {
      font-size: 30px;
      padding: 0;
    }

    .menu-sub[showsubmenu="true"]::before {
      display: none;
    }

    .menu-sub ul li {
      line-height: 0.9em;
      text-align: center;
    }

    .btn-rounded-blue,
    .header.rar .btn-rounded-blue {
      font-size: 5vw;
      height: auto;
      padding: 2.5vw 7vw;
      margin-left: 0;
    }

    .menu a::before {
      height: 4vw;
      width: 15vw;
      left: -3vw;
    }

    .cerrar-menu {
      font-size: 30px;
      color: #3374b0;
      position: absolute;
      right: 20px;
      top: -200px;
      background: none;
      border: none;
      outline: none;
      display: inline-block;
      transition: 0.7s transform cubic-bezier(0.785, 0.135, 0.15, 0.86);
    }

    nav[show="true"] .cerrar-menu {
      transform: translateY(220px);
    }

    .show-menu {
      width: 40px;
      height: 18px;
      background: none;
      display: inline-block;
      position: relative;
      border: none;
      outline: none;
    }

    .show-menu span {
      width: 40px;
      height: 2px;
      background: #3374b0;
      display: inline-block;
      position: absolute;
      left: 0;
      top: 0;
    }

    .show-menu span:nth-child(2n) {
      top: 50%;
      margin-top: -1px;
    }

    .show-menu span:last-of-type {
      top: auto;
      bottom: 0;
    }
  }

  @media screen and (max-width: 600px) {
    .header {
      padding: 15px 0;
      width: 100vw;
    }

    .header.rar {
      padding: 15px 0;
    }

    .header .container {
      padding: 0 10px;
    }

    .header img {
      max-width: 80px;
    }

    .header.rar img {
      transform: scale(1);
    }

    .btn-rounded-blue,
    .header.rar .btn-rounded-blue {
      padding: 0.5vw 7vw;
      font-size: 20px;
    }

    .menu-sub ul li a {
      font-size: 20px;
      padding: 0;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/parts/header.vue